// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"e19e59bb","160":"6565107b","208":"40798ab4","293":"e1e27ca8","453":"3ed8c997","516":"759ca36c","519":"6aa655b1","917":"167d05ea","946":"0d5ecda6"}[chunkId] + ".chunk.js";
};